import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@core/services/auth/auth.service";
import { BusinessService } from "@data/services/business.service";
import { NgxRolesService } from "ngx-permissions";
import { Permission } from "@shared/schemas/permission";
import { CustomSegmentService } from "@core/services/custom-segment.service";
import { Permissions } from "@shared/schemas/complete-login";
import { MenuService } from "@core/services/auth/menu.service";
import { switchMap } from "rxjs";
import { SidebarSubmenu } from "@shared/schemas/sidebar-submenu";

@Component({
	templateUrl: "./asaas-login.component.html",
	styleUrls: ["./asaas-login.component.scss"],
	standalone: false
})
export class AsaasLoginComponent implements OnInit {
	private apiKeyFromAsaas: string | null = null;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private authService: AuthService,
		private roles: NgxRolesService,
		private businessService: BusinessService,
		private segment: CustomSegmentService,
		private menuService: MenuService
	) {}

	ngOnInit(): void {
		this.setApiKeyFromAsaas();
		this.loginWithAsaasKey();
	}

	private setApiKeyFromAsaas(): void {
		this.apiKeyFromAsaas =
			this.route.snapshot.queryParamMap.get("x-api-key");
	}

	private hasNoPermission(permission: Permission): boolean {
		return (
			permission.modules.length === 0 &&
			this.authService.getUserType() === "USUARIO_GRUPO"
		);
	}

	private setPermissions(permissions: Permissions): void {
		this.roles.flushRolesAndPermissions();
		this.roles.addRoleWithPermissions("", [
			...permissions.modules,
			...permissions.pages,
			...permissions.actions,
			this.authService.getUserType()
		]);
	}

	private loadAndSetBusinessData(): void {
		if (this.authService.getUserSupport()) {
			return;
		}
		this.businessService
			.getBusinessDefault()
			.subscribe((businessDefault) =>
				this.businessService.setBusinessData(businessDefault)
			);
	}

	private loginWithAsaasKey(): void {
		if (this.apiKeyFromAsaas) {
			this.authService
				.loginByAsaas(this.apiKeyFromAsaas ?? "")
				.pipe(
					switchMap(({ permissions, loginResponse }) => {
						this.segment.track({
							table: "baseerp_login",
							screen: "Login",
							action: "Redirect Login"
						});
						if (this.hasNoPermission(permissions)) {
							return this.authService.logout();
						} else {
							this.setPermissions(permissions);
							this.loadAndSetBusinessData();
							this.authService.setSession(loginResponse);
							return this.menuService.loadMenus();
						}
					})
				)
				.subscribe({
					next: (menu) => {
						this.menuService.setMenuList(<SidebarSubmenu>menu);
					},
					complete: () => {
						void this.router.navigateByUrl("/home");
					},
					error: () => {
						void this.router.navigate(["../asaas-login-error"], {
							relativeTo: this.route
						});
					}
				});
		}
	}
}
